import Api from './Api'

export const GetRightsAvailsMeta = async () =>
  Api().get('reportsBuilderV2/rights-avails/meta')

/** Queues a background export and returns the job record immediately. */
export const PostRightsAvailsExport = async (payload) =>
  Api().post('reportsBuilderV2/rights-avails/export', payload)

export const GetRightsAvailsExportJobs = async (limit = 20) =>
  Api().get(`reportsBuilderV2/rights-avails/exports?limit=${limit}`)

export const GetRightsAvailsExportJob = async (jobId) =>
  Api().get(`reportsBuilderV2/rights-avails/exports/${jobId}`)

export const CancelRightsAvailsExportJob = async (jobId) =>
  Api().delete(`reportsBuilderV2/rights-avails/exports/${jobId}`)

/** Saved builder setups, stored server-side per user. */
export const GetRightsAvailsViews = async () =>
  Api().get('reportsBuilderV2/rights-avails/views')

export const SaveRightsAvailsView = async (view) =>
  Api().post('reportsBuilderV2/rights-avails/views', view)

export const DeleteRightsAvailsView = async (id) =>
  Api().delete(`reportsBuilderV2/rights-avails/views/${id}`)

export const getRightsAvailsDownloadUrl = (fileName, reportName) => {
  const token = localStorage.getItem('access_token')
  const baseURL = process.env.VUE_APP_BASEURL
  const name = encodeURIComponent(reportName || 'Rights Avails')
  return `${baseURL}/reportsBuilderV2/rights-avails/download/${fileName}?authorization=${token}&report_name=${name}`
}
